import { FormControl } from "@mui/material";
import { memo } from "react";
import Select from "react-select";
import Separator from "../../../../../core/components/Separator.tsx";

function FormTemplateEmbarque({
	contextoEmbarque,
	setValues,
	values,
	setValuesSelect,
	setValidator,
	valuesSelect,
	opcoesTemplate,
	labelTemplate,
	estiloFrota,
	embarqueTemplate,
	preencherDadosEditando,
	setEmpresaValido,
	setPedidoValido,
	setDestinatarioValido,
	setIcmsBackup,
	dadosFilial,
}) {
	return (
		<>
			{contextoEmbarque === "templateEmbarque" && (
				<div className="div-template">
					<p className="input-label-emb" htmlFor="embarque">
						Descrição Template
					</p>
					<input
						type="text"
						className="input-emb"
						style={{ width: "300px" }}
						onChange={(e) => {
							setValues((current) => ({
								...current,
								descricao: e.target.value,
							}));
						}}
						value={values.descricao || ""}
					/>
				</div>
			)}
			{contextoEmbarque !== "templateEmbarque" && (
				<div className="div-template">
					<p htmlFor="embarque">Usar Modelo</p>
					<Separator size="lg" />
					<FormControl sx={{ width: 250 }}>
						<Select
							value={valuesSelect.template}
							options={opcoesTemplate}
							formatOptionLabel={labelTemplate}
							styles={estiloFrota}
							placeholder=""
							noOptionsMessage={() => "Não há mais opções"}
							onChange={(e) => {
								const selectedOption = embarqueTemplate.find(
									(option) => option.idEmbarqueTemplete === e.idEmbarqueTemplete
								);
								if (selectedOption) {
									setValuesSelect((current) => ({
										...current,
										template: selectedOption,
									}));
									preencherDadosEditando(selectedOption);
									for (let chave in selectedOption) {
										if (
											selectedOption[chave] !== null &&
											chave !== "previsaoEmbarque" &&
											chave !== "dataEmbarque" &&
											chave !== "previsaoEntrega" &&
											chave !== "dataEntrega" &&
											chave !== "dataHoraChegadaEmbarque" &&
											chave !== "dataHoraEmbarcado" &&
											chave !== "dataHoraChegadaEntrega" &&
											chave !== "dataHoraEntregue"
										) {
											setValues((current) => ({
												...current,
												[chave]: selectedOption[chave],
											}));
										}
									}
									if (selectedOption.empresa !== null) {
										setValidator((current) => ({
											...current,
											validatorEmpresa: "true",
										}));
										setEmpresaValido(true);
									}
									if (selectedOption.filial !== null) {
										setValidator((current) => ({
											...current,
											validatorFilial: "true",
										}));
									}
									if (selectedOption.pedido !== null) {
										setValidator((current) => ({
											...current,
											validatorPedido: "true",
										}));
										setPedidoValido(true);
									}
									if (selectedOption.status !== null) {
										setValidator((current) => ({
											...current,
											validatorStatus: "true",
										}));
									}
									if (selectedOption.placaCavalo !== null) {
										setValidator((current) => ({
											...current,
											validatorPlacaCavalo: "true",
										}));
									}
									if (selectedOption.placaCarreta !== null) {
										setValidator((current) => ({
											...current,
											validatorPlacaCarreta: "true",
										}));
									}
									if (selectedOption.placaCarreta2 !== null) {
										setValidator((current) => ({
											...current,
											validatorPlacaCarreta2: "true",
										}));
									}
									if (selectedOption.proprietario !== null) {
										setValidator((current) => ({
											...current,
											validatorProprietario: "true",
										}));
									}
									if (selectedOption.motorista !== null) {
										setValidator((current) => ({
											...current,
											validatorMotorista: "true",
										}));
									}
									if (selectedOption?.icms !== null) {
										setValidator((current) => ({
											...current,
											validatorIcms: "true",
										}));
									}
									if (selectedOption.freteFiscal !== null) {
										setValidator((current) => ({
											...current,
											validatorFreteFiscal: "true",
										}));
									}
									if (selectedOption.meioPagamento !== null) {
										setValidator((current) => ({
											...current,
											validatorMeioPagamento: "true",
										}));
									}
									if (selectedOption.mercadoria !== null) {
										setValidator((current) => ({
											...current,
											validatorMercadoria: "true",
										}));
									}
									if (selectedOption.destinatario !== null) {
										setValidator((current) => ({
											...current,
											validatorDestinatario: "true",
										}));
										setDestinatarioValido(true);
									}
									if (selectedOption.embarcador !== null) {
										setValidator((current) => ({
											...current,
											validatorEmbarcador: "true",
										}));
									}
									contextoEmbarque !== "frota" &&
										setIcmsBackup((current) => ({
											...current,
											icms: selectedOption?.icms,
										}));
									dadosFilial?.forEach((item) => {
										if (contextoEmbarque === item.contexto) {
											setValues((current) => ({
												...current,
												unidEmbarque: item.nomeFilial,
												filialEmpresaId: item.id,
											}));
										}
									});
									setValues((current) => ({
										...current,
										contexto: contextoEmbarque,
									}));
								}
							}}
						/>
					</FormControl>
				</div>
			)}
		</>
	);
}

export default memo(FormTemplateEmbarque);
